import { humanizePriceFromCents as humanizePriceFromCentsBase } from '@i22team/rocket';

export const humanizePriceFromCents = (value: number) =>
  humanizePriceFromCentsBase(value, { hideTrailingZeros: true });
